import { UrlHelperExtensions } from "@/url_helpers";
import "@/pages/vendors/tooltipster";
import "./index.scss";
import jqueryDataUtil from "@/common/jqueryDataUtil";
import { ensureAttributesForSelector } from "@/pages/base/utils";
$(function () {
  "use strict";

  ensureAttributesForSelector(".js-user-hovercard", ["data-userid"]);
  $(document.body).on("mouseenter", ".js-user-hovercard", function () {
    var link = this;
    var $link = $(link);
    var userId = jqueryDataUtil.requiredNumber($link, "userid"); // mta.clickStat("userhovercard", { userid: userId + "" });

    $link.tooltipster({
      interactive: true,
      updateAnimation: "scale",
      side: ["right", "left", "top", "bottom"],
      content: $("<div class='user-hovercard'>...</div>"),
      functionBefore: function functionBefore(instance, helper) {
        var $origin = $(helper.origin);

        if (jqueryDataUtil.optionalBoolean($origin, "loaded") !== true) {
          $.get(UrlHelperExtensions.UserHoverCardUrl(userId), function (data) {
            // call the 'content' method to update the content of our tooltip with the returned data.
            // note: this content update will trigger an update animation (see the updateAnimation option)
            instance.content($(data)); // instance.content($(data));

            $origin.data("loaded", true);
          });
        }
      }
    }).tooltipster("open");
    return false;
  });
});